export const styles = {
  container: [
    "max-w-[486px]",
    "w-full",
    "mt-auto",
    "bg-white",
    "sm:mt-16",
    "sm:ml-24",
    "rounded-xl",
    "shadow-lg",
    "p-3",
    "sm:py-10",
    "sm:px-11",
    "pointer-events-auto",
    "text-center",
    "sm:text-left",
  ].join(" "),
  title: ["font-bold", "text-xl", "sm:text-4xl"].join(" "),
  subtitle: ["mt-3", "sm:mt-4", "text-base", "sm:text-lg", "text-gray-me"].join(
    " "
  ),
  button: [
    "text-lg",
    "sm:text-2xl",
    "py-2",
    "sm:py-4",
    "w-full",
    "bg-yellow-me",
    "rounded-full",
    "mt-2",
    "sm:mt-7",
  ].join(" "),
};
